export const BorrowerRegistrationStep = {
	NotStarted: -1,
	PersonalInformation: 0,
	BusinessInformation: 1,
	DocumentVerification: 2,
	Declaration: 3,
};
